import { render } from "./5.ContactsStep.vue?vue&type=template&id=16555f42"
import script from "./5.ContactsStep.vue?vue&type=script&lang=js"
export * from "./5.ContactsStep.vue?vue&type=script&lang=js"

import "./5.ContactsStep.vue?vue&type=style&index=0&id=16555f42&lang=scss"

import exportComponent from "/Volumes/Samsung_T5/Work/Projects/my_projects/profiguide/profiguide/src/profiguide/static/web_plugin/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__